(function () {
  if (window.elaaFormFeedback) return;
  window.elaaFormFeedback = true;
  function initialize(scope) {
    const error = scope.querySelector('[data-elaa-form-error]');
    if (error) error.focus();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document));
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
}());
